import { c as _c } from "react/compiler-runtime";
/**
  * Do not edit this file manually.
  * It is automatically generated.
  * Run `npm run svg:convert` to regenerate.
  */
import type React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
export default function SpeedIcon(props) {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      maskType: "alpha"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <mask id="mask0_13636_32998" style={t0} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><rect width="24" height="24" /></mask>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <g mask="url(#mask0_13636_32998)"><path d="M10.6038 15.3463C10.9589 15.7013 11.4163 15.8698 11.976 15.852C12.5355 15.834 12.9461 15.6321 13.2078 15.2463L18.6345 7.38475L10.7538 12.7923C10.3616 13.0539 10.1498 13.4562 10.1183 13.999C10.0869 14.542 10.2488 14.9911 10.6038 15.3463ZM12 4.5C12.9513 4.5 13.8427 4.62467 14.674 4.874C15.5055 5.12333 16.3084 5.50058 17.0828 6.00575L15.673 6.91725C15.1038 6.61475 14.5138 6.38625 13.903 6.23175C13.292 6.07725 12.6577 6 12 6C9.78333 6 7.89583 6.77917 6.3375 8.3375C4.77917 9.89583 4 11.7833 4 14C4 14.7 4.09583 15.3917 4.2875 16.075C4.47917 16.7583 4.75 17.4 5.1 18H18.9C19.2833 17.3667 19.5625 16.7083 19.7375 16.025C19.9125 15.3417 20 14.6333 20 13.9C20 13.3 19.926 12.6927 19.778 12.078C19.6298 11.4632 19.4013 10.8795 19.0923 10.327L20.0038 8.91725C20.4974 9.72625 20.8677 10.5356 21.1145 11.3453C21.3612 12.1549 21.4897 12.9963 21.5 13.8693C21.5102 14.7744 21.4083 15.6298 21.1943 16.4355C20.9801 17.2413 20.6577 18.0295 20.227 18.8C20.0948 19.0167 19.9089 19.1875 19.6693 19.3125C19.4294 19.4375 19.173 19.5 18.9 19.5H5.1C4.83333 19.5 4.58175 19.4359 4.34525 19.3077C4.10875 19.1794 3.918 18.9973 3.773 18.7615C3.391 18.0948 3.08333 17.3679 2.85 16.5808C2.61667 15.7936 2.5 14.9333 2.5 14C2.5 12.6937 2.74783 11.4656 3.2435 10.3158C3.73917 9.16592 4.41575 8.15883 5.27325 7.2945C6.13092 6.43017 7.13917 5.74833 8.298 5.249C9.457 4.74967 10.691 4.5 12 4.5Z" /></g>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props) {
    t3 = <SvgIcon {...props}>{t1}{t2}</SvgIcon>;
    $[3] = props;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}